import { useTranslation } from "react-i18next";

/**
 * Footer. Mark on the left, Product + Connect columns on the right.
 * Coordinate-style copyright line.
 */
export function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  return (
    <footer className="relative">
      <div className="mx-auto max-w-[1320px] px-6 lg:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-[1.6fr_1fr_1fr] gap-12 lg:gap-8 mb-16">
          {/* Mark */}
          <div>
            <a href="/" className="inline-flex items-center gap-3">
              <img src={`${import.meta.env.BASE_URL}logo.png`} alt="UltraScan" className="w-10 h-10" />
              <span className="font-display text-2xl">UltraScan</span>
            </a>
            <p className="mt-5 text-sm text-[color:var(--color-app-text)]/70 leading-relaxed max-w-sm">
              {t("footer.tagline")}
            </p>
            <div className="mt-6 coord-mono opacity-50">{t("footer.coord")}</div>
          </div>

          <FooterCol
            label={t("footer.product.label")}
            links={[
              { label: t("footer.product.openDashboard"), href: "/app" },
              { label: t("footer.product.pricing"),       href: "#pricing" },
              { label: t("footer.product.changelog"),     href: "https://github.com/Uszi/UltraScan/releases" },
            ]}
          />
          <FooterCol
            label={t("footer.connect.label")}
            links={[
              { label: t("footer.connect.github"), href: "https://github.com/Uszi/UltraScan" },
              { label: t("footer.connect.email"),  href: "mailto:hi@ultrascan.ai" },
              { label: t("footer.connect.status"), href: "https://status.ultrascan.ai" },
              { label: t("footer.connect.terms"),  href: "#" },
            ]}
          />
        </div>

        <div className="border-t border-[color:var(--color-app-edge)] pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 coord-mono opacity-70">
          <div>{t("footer.copyright", { year })}</div>
          <div className="flex items-center gap-3">
            <span>{t("footer.statusLine")}</span>
            <span className="w-1.5 h-1.5 rounded-full bg-[color:var(--color-leaf)] pulse-dot" />
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({
  label,
  links,
}: {
  label: string;
  links: Array<{ label: string; href: string }>;
}) {
  return (
    <div>
      <div className="label-mono opacity-60 mb-4">{label}</div>
      <ul className="space-y-2.5">
        {links.map((l) => (
          <li key={l.label}>
            <a
              href={l.href}
              className="text-sm text-[color:var(--color-app-text)]/85 hover:text-[color:var(--color-app-text)] underline-offset-4 hover:underline decoration-dotted"
            >
              {l.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
